/* @flow */

import React, { type Node } from 'react';
import { Button } from './styled';

type TProps = {
	index: number,
	isActive: boolean,
	onPageChange: (page: number) => void,
	dataQa: string,
};

const PageButton = ({ index, isActive, onPageChange, dataQa }: TProps): Node => (
	<Button data-qa={dataQa && `${dataQa}_n_btn`} isActive={isActive} onClick={onPageChange} key={index} type="button">
		{index}
	</Button>
);

export default PageButton;
